import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { BRAND } from "@/content";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/regulate", label: "REGULATE" },
  { to: "/begin-here", label: "Begin Here" },
  { to: "/about", label: "About" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-ivory/90 backdrop-blur-md border-b border-stone/60">
      <nav className="mx-auto max-w-6xl px-6 md:px-10 h-16 md:h-20 flex items-center justify-between" aria-label="Main navigation">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-serif text-lg md:text-xl tracking-[0.25em] text-charcoal"
          onClick={() => setOpen(false)}
        >
          {BRAND}
        </Link>

        <div className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.2em] transition-colors duration-500 ${
                  isActive ? "text-deepteal" : "text-taupe hover:text-charcoal"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/regulate"
            data-testid="nav-get-regulate-button"
            className="bg-teal text-ivory text-xs uppercase tracking-[0.25em] px-6 py-2.5 hover:bg-deepteal transition-colors duration-500"
          >
            Get REGULATE
          </Link>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          className="md:hidden text-charcoal"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="md:hidden overflow-hidden border-t border-stone/60 bg-ivory"
            data-testid="nav-mobile-menu"
          >
            <div className="flex flex-col px-6 py-6 gap-5">
              {LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={({ isActive }) =>
                    `text-sm uppercase tracking-[0.2em] ${isActive ? "text-deepteal" : "text-taupe"}`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/regulate"
                onClick={() => setOpen(false)}
                data-testid="nav-mobile-get-regulate-button"
                className="mt-2 inline-block text-center bg-teal text-ivory text-xs uppercase tracking-[0.25em] px-6 py-3"
              >
                Get REGULATE
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
